import { render, staticRenderFns } from "./KollelApplicationLogs.vue?vue&type=template&id=479ceffa&"
import script from "./KollelApplicationLogs.vue?vue&type=script&lang=js&"
export * from "./KollelApplicationLogs.vue?vue&type=script&lang=js&"
import style0 from "./KollelApplicationLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports